import { QueueMachineCallerCurrentState, AppointmentResponse } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface UseQueueMachineCallerCurrentStateParams {
  queueMachineId: number | null
}

export function useQueueMachineCallerCurrentState({
  queueMachineId,
}: UseQueueMachineCallerCurrentStateParams) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<{
    success: boolean
    data: QueueMachineCallerCurrentState & { appointment?: AppointmentResponse }
  }>(
    token && queueMachineId ? `/api/queue-machine/${queueMachineId}/caller/current-state` : null,
    undefined,
    token ?? '',
  )

  return {
    currentState: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
